module.exports = __webpack_public_path__ + "img/bnt.5dd9ca28.svg";